// Thin adapter over the canonical language metadata in
// `@travel-planner/shared/schemas` (the single source of truth for language
// names, flags, and picker ordering). This module only re-exports those
// helpers under the app-local names its consumers already use — it holds NO
// language data of its own, so nothing can drift from the shared enum.

import type { LanguageCode } from '@travel-planner/shared/schemas/facility';
import {
  languageName,
  compareLanguages as sharedCompareLanguages,
  languageFlag as sharedLanguageFlag,
} from '@travel-planner/shared/schemas';

export const languageLabel = (code: LanguageCode): string => languageName(code);

export const languageFlag = (code: LanguageCode): string =>
  sharedLanguageFlag(code);

export const compareLanguages = (a: LanguageCode, b: LanguageCode): number =>
  sharedCompareLanguages(a, b);
